import * as API from '../../_api';
import * as Sentry from '@sentry/vue';

// @ts-ignore
export const addGuests = async ({commit, dispatch}, {id, guests}) => {
  try {
    await API.addGuests(id, guests);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readGuests = async ({commit, dispatch}, {id}) => {
  try {
    const guests = await API.readGuests(id);
    commit('setGuests', guests);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const removeGuest = async ({commit, dispatch}, {id, eventGuestId}) => {
  try {
    await API.removeGuest(id, eventGuestId);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const updateGuest = async ({commit, dispatch}, {id, guest}) => {
  try {
    await API.updateGuest(id, guest);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};
